export default __webpack_public_path__ + "75933a94db3dc8fb21042b7d8e0d394a.svg";